import * as React from "react";
import theme from "./theme.module.scss";

interface INavLinkGroupProps {
    children?: any
}

export default function NavGroup({children}: INavLinkGroupProps) {
    return <>{React.Children.toArray(children).filter(React.isValidElement).map((child: React.ReactElement) => {
        return (
            <div className={theme.navGroup} key={child.key}>
                {child}
            </div>
        )
    })}</>;
}
